// extracted by mini-css-extract-plugin
export default {"storeNameBox":"Components-module--storeNameBox--MuEUh","OffersSizing":"Components-module--OffersSizing--xcXPI"};